import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { errorContentResolver } from './errorContentResolver'
import useCurrentUser from 'lib/hooks/useCurrentUser'
import { ERROR_STYLE } from 'lib/errors'
import { isDev } from 'lib/env'
import { isAdmin } from 'lib/utils/store/currentUser'

import StatusMessage from 'components/StatusMessage'
import DevError from './DevError'

import 'components/Errors/app-error-message.css'
import CopyClipboardButton from 'components/UI/CopyClipboardButton/CopyClipboardButton'

const AppErrorMessage = ({
    appError,
    sentryEventId,
    originalError = false,
    contentOverride = false,
    defaultMessage = false,
    container = true,
}) => {
    const currentUser = useCurrentUser()
    const { t } = useTranslation('errors')

    let content

    // contentOverride function can be used to render some special error content
    if (contentOverride) content = contentOverride(appError)
    if (!content) content = errorContentResolver(t, appError, defaultMessage)

    const style = t(`errors:${appError.type}.${appError.code}.style`, ERROR_STYLE.ERROR)

    const message = (
        <StatusMessage
            type="error"
            icon={style === 'info' ? 'icon_info_circle' : 'icon_alert_circle_yellow'}
            error={
                isDev() || isAdmin(currentUser) ? (
                    <DevError
                        currentUser={currentUser}
                        originalError={originalError}
                        appError={appError}
                        sentryEventId={sentryEventId}
                    />
                ) : null
            }
            title={false}
            appContext={['appError', appError.type, appError.code]}
        >
            <div className="error-message-content">
                <div className="error-content">
                    {content}
                </div>
                {appError.errorLogId && (
                    <div className="error-content">{t('common:errorId')}:&nbsp;{appError.errorLogId}&nbsp;
                        <CopyClipboardButton copiedText={t('common:errorIdCopied')} value={appError.errorLogId} />
                    </div>
                )}
            </div>
        </StatusMessage>
    )

    return (
        <div className="app-error-message">
            {container ? (
                <div className="container">
                    {message}
                </div>
            ) : message}
        </div>
    )
}

AppErrorMessage.propTypes = {
    appError: PropTypes.object.isRequired,
    originalError: PropTypes.any,
    contentOverride: PropTypes.func,
    defaultMessage: PropTypes.any,
    sentryEventId: PropTypes.string,
}

export default AppErrorMessage
